import { render } from "./Datepicker.vue?vue&type=template&id=0a876bfe&scoped=true"
import script from "./Datepicker.vue?vue&type=script&lang=js"
export * from "./Datepicker.vue?vue&type=script&lang=js"

import "./Datepicker.vue?vue&type=style&index=0&id=0a876bfe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a876bfe"]])

export default __exports__